import { LoggerProvider, ErrorBoundary } from '@ori/logger';
import type { FC } from 'react';

import { BasketProvider } from '../components';
import { APP_NAME } from '../constants';
import { mainLogger } from '../logger';
import { ApiProvider } from './ApiProvider';

export const BasketProviderController: FC = () => (
  <LoggerProvider logger={mainLogger}>
    <ErrorBoundary areaName={`${APP_NAME}-boundary`}>
      <ApiProvider>
        <BasketProvider />
      </ApiProvider>
    </ErrorBoundary>
  </LoggerProvider>
);
